import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import PublicLayout from '../components/layout/PublicLayout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import PublicLanding from '../pages/PublicLanding';
import BlogIndexPage from '../pages/BlogIndexPage';
import BlogPostPage from '../pages/BlogPostPage';
import PublicAgentPage from '../pages/PublicAgentPage';
import FeedPage from '../pages/FeedPage';
import TrainingLibraryPage from '../pages/TrainingLibraryPage';
import TrainingSessionPage from '../pages/TrainingSessionPage';
import TrainingUploadPage from '../pages/training/TrainingUploadPage';
import SessionDraftPage from '../pages/training/SessionDraftPage';
import ReelDraftPage from '../pages/training/ReelDraftPage';
import TrainingStaleDraftsPage from '../pages/training/TrainingStaleDraftsPage';
import ReelEditPage from '../pages/training/ReelEditPage';
import TrainingArchivePage from '../pages/training/TrainingArchivePage';
import TrainingRowListPage from '../pages/training/TrainingRowListPage';
import ResourceHubPage from '../pages/ResourceHubPage';
import ResourceDetailPage from '../pages/ResourceDetailPage';
import ResourceUploadPage from '../pages/resources/ResourceUploadPage';
import ResourceVersionPage from '../pages/resources/ResourceVersionPage';
import MyProfilePage from '../pages/MyProfilePage';
import CommunityPage from '../pages/CommunityPage';
import QuestionDetailPage from '../pages/QuestionDetailPage';
import LiveSessionCalendarPage from '../pages/LiveSessionCalendarPage';
import LoginPage from '../pages/auth/LoginPage';
import RegisterPage from '../pages/auth/RegisterPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';
import UserManagementPage from '../pages/admin/UserManagementPage';
import OgDefaultsPage from '../pages/admin/OgDefaultsPage';

function AdminRoute() {
  return (
    <ProtectedRoute permission="view_agent_conflicts" />
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registro" element={<RegisterPage />} />
      <Route path="/recuperar-contrasena" element={<ForgotPasswordPage />} />
      <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />

      <Route element={<PublicLayout />}>
        <Route path="/" element={<PublicLanding />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:id" element={<BlogPostPage />} />
        <Route path="/agente/:id" element={<PublicAgentPage />} />
      </Route>

      <Route path="/app" element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<FeedPage />} />
          <Route path="entrenamientos" element={<TrainingLibraryPage />} />
          <Route path="entrenamientos/subir" element={<TrainingUploadPage />} />
          <Route path="entrenamientos/borradores-antiguos" element={<TrainingStaleDraftsPage />} />
          <Route path="entrenamientos/archivo" element={<TrainingArchivePage />} />
          <Route path="entrenamientos/fila/:rowId" element={<TrainingRowListPage />} />
          <Route path="entrenamientos/:id/borrador" element={<SessionDraftPage />} />
          <Route path="reels/:id/borrador" element={<ReelDraftPage />} />
          <Route path="reels/:id/editar" element={<ReelEditPage />} />
          <Route path="reels/:id/recorte" element={<ReelEditPage />} />
          <Route path="entrenamientos/:id" element={<TrainingSessionPage />} />
          <Route path="recursos" element={<ResourceHubPage />} />
          <Route path="recursos/subir" element={<ResourceUploadPage />} />
          <Route path="recursos/:id/versionar" element={<ResourceVersionPage />} />
          <Route path="recursos/:id" element={<ResourceDetailPage />} />
          <Route path="perfil" element={<MyProfilePage />} />
          <Route path="comunidad" element={<CommunityPage />} />
          <Route path="comunidad/faq/:id" element={<QuestionDetailPage />} />
          <Route path="herramientas" element={<Navigate to="/app/herramientas/calendario" replace />} />
          <Route path="herramientas/calendario" element={<LiveSessionCalendarPage />} />
          <Route path="admin" element={<AdminRoute />}>
            <Route path="usuarios" element={<UserManagementPage />} />
            <Route path="og-defaults" element={<OgDefaultsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
